import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { SystemGlobalsService } from '../system-globals.service';

@Injectable({
  providedIn: 'root'
})
export class CrmFeatureGuard implements CanActivate {
  constructor(private globals: SystemGlobalsService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.globals.isFeatureEnabled('crm')) {
      return true;
    }

    window.location.href = '/';
    return false;
  }
}
